<div class="people-details">
  <app-people-edit [isCreating]="isCreating" [id]="id"></app-people-edit>
</div>
